import { render, staticRenderFns } from "./TextOverflowTooltip.vue?vue&type=template&id=0d089f40&"
import script from "./TextOverflowTooltip.vue?vue&type=script&lang=js&"
export * from "./TextOverflowTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TextOverflowTooltip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports